import { createPortal } from 'react-dom'
import { useBoolean } from 'usehooks-ts'
import NoneAnchor from '../NoneAnchor'

const isChrome = navigator.userAgent.includes('Chrome')

const BrowserAlert = () => {
  const { value, setFalse } = useBoolean(!isChrome)
  return (
    value &&
    createPortal(
      <div
        className="guide_msg3"
        style={{ backgroundColor: 'rgba(240, 89, 94, 0.9)' }}>
        <strong className="screen_out">최적화 브라우저 안내</strong>
        <p className="desc_msg">
          이 사이트는 <em className="fs_line">Chrome</em> 브라우저에
          최적화되어있어, 현재 브라우저에서는 정상적으로 동작하지 않을 수
          있습니다.
        </p>
        <NoneAnchor className="link_close" onClick={setFalse}>
          <span className="ico_comm ico_close">닫기</span>
        </NoneAnchor>
      </div>,
      document.body
    )
  )
}
export default BrowserAlert
